import { aboutUsConstants } from "../../actions/constants"

const initialState = {
    aboutUs: [],
    currencyUsed: "$", // 💰 Дефолтное значение
    loading: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case aboutUsConstants.GET_ABOUT_US_REQUEST:
            return {
                ...state,
                loading: true
            }
        case aboutUsConstants.GET_ABOUT_US_SUCCESS:
            return {
                ...state,
                aboutUs: action.payload.aboutUs,
                currencyUsed: action.payload.aboutUs[0]?.currencyUsed || state.currencyUsed, // ✅ Обновляем валюту, но fallback — старая
                loading: false
            }
        case aboutUsConstants.GET_ABOUT_US_FAILURE:
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}
